import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ButtonV3Component, IconV3Component } from '@gea/digital-ui-lib';
import { AssetTableRow } from '../data-maintenance.model';
import { FilePreviewContainerComponent } from './file-preview-container/file-preview-container.component';

@Component({
  selector: 'app-file-preview-sidebar',
  standalone: true,
  imports: [ButtonV3Component, IconV3Component, FilePreviewContainerComponent],
  templateUrl: './file-preview-sidebar.component.html',
  styleUrls: ['./file-preview-sidebar.component.scss'],
})
export class FilePreviewSidebarComponent {
  @Input() asset: AssetTableRow | null = null;
  @Input() canMutate = true;
  @Input() allowUpload = true;
  @Input() canReplace = true;
  @Output() close = new EventEmitter<void>();
  @Output() undoChanges = new EventEmitter<AssetTableRow>();
  @Output() replace = new EventEmitter<AssetTableRow>();
  @Output() rename = new EventEmitter<AssetTableRow>();
  @Output() download = new EventEmitter<AssetTableRow>();
  @Output() delete = new EventEmitter<AssetTableRow>();

  closeSidebar(): void {
    this.close.emit();
  }

  onUndoChanges(): void {
    if (this.asset) {
      this.undoChanges.emit(this.asset);
    }
  }

  onReplace(): void {
    if (this.asset) {
      this.replace.emit(this.asset);
    }
  }

  onRename(): void {
    if (this.asset) {
      this.rename.emit(this.asset);
    }
  }

  onDownload(): void {
    if (this.asset) {
      this.download.emit(this.asset);
    }
  }

  onDelete(): void {
    if (this.asset) {
      this.delete.emit(this.asset);
    }
  }

  getFileSize(): string {
    return this.asset?.size || 'Unknown';
  }

  getFileType(): string {
    return this.asset?.fileType || 'Unknown';
  }
}
